<template>

    <div>
        <!--    Navbar start  -->

        <!-- <Header></Header> -->

        <slot name="home"></slot>
        <!--    Footer start -->
        <!-- <Footer></Footer> -->
    </div>
</template>

<script>
    

    export default {
        name: "Master",
       
        components: {
        

        }
    }
</script>

<style scoped>

</style>